// Note: when migrate to typescript, please double if it is able
// to check the instance of this class
// ex: (new APIError(...)) instanceof APIError should be TRUE

class APIError extends Error {
  constructor(message, fetcherError) {
    super(message);

    this.apiError = true;

    if (fetcherError) {
      this.response = {
        data: fetcherError.response?.data,
        status: fetcherError.response?.status,
      };
    }
  }

  static isApiError(error) {
    return error?.apiError;
  }
}

export default APIError;
